import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class IndexDBService {
  db;
  public _databaseOpenContainer = new BehaviorSubject<any>(undefined);
  public databaseOpenContainer$ = this._databaseOpenContainer.asObservable();

  constructor() {}
  // async connect(id) {
  //   localStorage.setItem("ndbx", "false");
  //   // const request = await indexedDB.open(environment.local_db,environment.local_db_version);
  //   console.log("user_id", id);
  //   if (id==null){
  //     id = localStorage.getItem("id");
  //   }
  //   const dbName = `${environment.local_db}_${id}`;
  //   const request = await indexedDB.open(dbName, environment.local_db_version);

  //   request.onerror = (event) => {
  //     // console.log("DB ERROR", event);
  //   };

  //   request.onsuccess = (event: any) => {
  //     this.db = event.target.result;
  //     localStorage.setItem("ndbx", "true");
  //     this._databaseOpenContainer.next(true);
  //   };

  //   request.onupgradeneeded = (event: any) => {
  //     // console.log("DB OK", event);
  //     // Save the IDBDatabase interface
  //     const db = event.target.result;
  //     // Create an objectStore for this database
  //     const chats = db.createObjectStore("chats", { keyPath: "id" });
  //     chats.createIndex("type", "type");

  //     const message = db.createObjectStore("messages", { keyPath: "message.message_id" });

  //     let keyPath = ["message.chat.id","message.gmid"];
  //     message.createIndex("chat", keyPath);

  //     keyPath = ["message.chat.id", "message.reply_to_message_id", "message.gmid"];
  //     message.createIndex("gmid", keyPath);

  //     keyPath = ["message.chat.id", "message.reply_to_message_id", "message.user", "message.gmid"];
  //     message.createIndex("reply", keyPath);

  //     const displayMessages = db.createObjectStore("displayMessages", { keyPath: "message.chat.id" });

  //     const blob = db.createObjectStore("blob", { keyPath: "id" });


  //     const tab = db.createObjectStore("tab", { keyPath: "id" });
  //     tab.createIndex("cat", "cat");


  //     const menus = db.createObjectStore("menu", { keyPath: "menu_id" });
  //     menus.createIndex("cat", "cat");
  //     menus.createIndex("grp", "menu_group");

  //     const app = db.createObjectStore("app", { keyPath: "id" });
  //     const items = db.createObjectStore("item", { keyPath: "id" });
  //     const rows = db.createObjectStore("row", { keyPath: "row_id" });
  //     rows.createIndex("menu", "menu_id");
  //     const buttons = db.createObjectStore("button", { keyPath: "button_id" });
  //     buttons.createIndex("row", "row_id");

  //     const user = db.createObjectStore("user", { keyPath: ["message.chat.id", "message.reply_to_message_id", "message.from.id"]});
  //     keyPath = ["message.chat.id", "message.reply_to_message_id", "message.from.id", "message.gmid"];
  //     user.createIndex("gmid", keyPath);
  //     user.createIndex("user", "message.from.id");

  //     const mschedule = db.createObjectStore("schedule", { keyPath: "message.message_id" });
  //     localStorage.setItem("ndbx", "true");
  //     // this._databaseOpenContainer.next(true);
  //   };

  //   request.onblocked = (event) => {
  //     console.warn('Database upgrade blocked: another tab is open.');
  //     alert('Please close other open tabs of this app to continue.');
  //   };

  //   return this.db;
  // }

  async connect(id) {
    localStorage.setItem("ndbx", "false");
    if (id == null) {
      id = localStorage.getItem("id");
    }
    const dbName = `${environment.local_db}_${id}`;

    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName, environment.local_db_version);

      request.onerror = (event) => {
        console.error("DB ERROR", event);
        reject(event); // 💥 Very important
      };

      request.onsuccess = (event: any) => {
        this.db = event.target.result;
        localStorage.setItem("ndbx", "true");
        this._databaseOpenContainer.next(true);
        resolve(this.db); // ✅ Only resolve when DB is fully open
      };

      request.onupgradeneeded = (event: any) => {
        const db = event.target.result;

        const chats = db.createObjectStore("chats", { keyPath: "id" });
        chats.createIndex("type", "type");

        const message = db.createObjectStore("messages", { keyPath: "message.message_id" });

        let keyPath = ["message.chat.id", "message.gmid"];
        message.createIndex("chat", keyPath);

        keyPath = ["message.chat.id", "message.reply_to_message_id", "message.gmid"];
        message.createIndex("gmid", keyPath);

        keyPath = ["message.chat.id", "message.reply_to_message_id", "message.user", "message.gmid"];
        message.createIndex("reply", keyPath);

        const displayMessages = db.createObjectStore("displayMessages", { keyPath: "message.chat.id" });
        const blob = db.createObjectStore("blob", { keyPath: "id" });

        const tab = db.createObjectStore("tab", { keyPath: "id" });
        tab.createIndex("cat", "cat");

        const menus = db.createObjectStore("menu", { keyPath: "menu_id" });
        menus.createIndex("cat", "cat");
        menus.createIndex("grp", "menu_group");

        const app = db.createObjectStore("app", { keyPath: "id" });
        const items = db.createObjectStore("item", { keyPath: "id" });
        const rows = db.createObjectStore("row", { keyPath: "row_id" });
        rows.createIndex("menu", "menu_id");
        const buttons = db.createObjectStore("button", { keyPath: "button_id" });
        buttons.createIndex("row", "row_id");

        const user = db.createObjectStore("user", { keyPath: ["message.chat.id", "message.reply_to_message_id", "message.from.id"] });
        keyPath = ["message.chat.id", "message.reply_to_message_id", "message.from.id", "message.gmid"];
        user.createIndex("gmid", keyPath);
        user.createIndex("user", "message.from.id");

        const mschedule = db.createObjectStore("schedule", { keyPath: "message.message_id" });

        localStorage.setItem("ndbx", "true");
      };

      request.onblocked = (event) => {
        console.warn('Database upgrade blocked: another tab is open.');
        alert('Please close other open tabs of this app to continue.');
      };
    });
  }

    async waitUntilDbReady(): Promise<void> {
    while (!this.db) {
      console.log("⏳ Waiting for IndexedDB to initialize...");
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
  }



  // add new record to db with success status
  async addItem(table, data) {
    if (this.db) {
      const objectStore = this.db
        .transaction(table, "readwrite")
        .objectStore(table);

      const request = objectStore.add(data);
      request.onsuccess = (event) => {
        // event.target.result === customer.ssn;
        return true;
      };
      request.onerror = (event) => {
        return false;
      };
    }
  }

  // add new record to db with success status
  addMessage(table, data) {
    return new Promise((resolve, reject) => {
      if (this.db) {
        const transaction = this.db.transaction(table, "readwrite");
        const objectStore = transaction.objectStore(table);
        const request = objectStore.add(data);

        request.onsuccess = () => {
          resolve(true);
        };

        request.onerror = (event: any) => {
          resolve(false);
        };
      } else {
        resolve(false);
      }
    });
  }

  // here to insert new record to db
  insertItem(table, data) {
    if (this.db) {
      const objectStore = this.db
        .transaction(table, "readwrite")
        .objectStore(table);
      const request = objectStore.add(data);
      return request;
    }
  }

  // here to update db record with success status
  putItem(table, data) {
    if (this.db) {
      const objectStore = this.db
        .transaction(table, "readwrite")
        .objectStore(table);

      const request = objectStore.put(data);
      request.onsuccess = (event) => {
        // event.target.result === customer.ssn;
        return true;
      };
      request.onerror = (event) => {
        return false;
      };
    }
  }

  // update db record with request
  updateItem(table, data) {
    if (this.db) {
      const objectStore = this.db
        .transaction(table, "readwrite")
        .objectStore(table);

      const request = objectStore.put(data);
      return request;
    }
  }

  // update all list items
  updateItemList(table, data) {
    if (this.db) {
      const objectStore = this.db
        .transaction(table, "readwrite")
        .objectStore(table);
      data.forEach((item) => {
        const request = objectStore.put(item);
        request.onsuccess = (event) => {
          // event.target.result === customer.ssn;
          return true;
        };
        request.onerror = (event) => {
          return false;
        };
      });
    }
  }

  // get record by key
  getItem(table, key) {
    if (this.db) {
      const request = this.db.transaction(table).objectStore(table).get(key);
      return request;
    }
  }

  // get record by key
  // getItemOnsucss(table, key) {
  //   if (this.db) {
  //     const request = this.db.transaction(table).objectStore(table).get(key);
  //     return new Promise((resolve, reject) => {
  //       request.onsuccess = (event) => {
  //         resolve(request.result);
  //       };
  //     });
  //   }
  // }


  getItemOnsucss(table: string, key: IDBValidKey): Promise<any> {
  return new Promise((resolve, reject) => {
    if (!this.db) {
      reject(new Error("IndexedDB not initialized yet"));
      return;
    }

    const tx = this.db.transaction(table, "readonly");
    const store = tx.objectStore(table);
    const request = store.get(key);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);

    tx.onerror = () => reject(tx.error);
  });
}
  getItemListOnsucss(table, indexName, query) {
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .getAll(query);
      } else {
        if (query) {
          request = this.db.transaction(table).objectStore(table).getAll(query);
        } else {
          request = this.db.transaction(table).objectStore(table).getAll();
        }
      }

      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          resolve(request.result);
        };
      });
    }
  }

  getItemListLowerBoundOnsucss(table, indexName, lowerBound) {
    var range = IDBKeyRange.lowerBound(lowerBound);
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .getAll(range);
      } else {
        if (range) {
          request = this.db.transaction(table).objectStore(table).getAll(range);
        } else {
          request = this.db.transaction(table).objectStore(table).getAll();
        }
      }

      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          resolve(request.result);
        };
      });
    }
  }

  getItemList(table, indexName, query) {
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .getAll(query);
      } else {
        request = this.db.transaction(table).objectStore(table).getAll(query);
      }
      return request;
    }
  }


  getItemAll(table) {
    if (this.db) {
      let request;
        request = this.db
          .transaction(table)
          .objectStore(table)
          .getAll();
      return request;
    } else {

    }
  }

  getItemRange(table, indexName, lowerBound, upperBound) {
    var range = IDBKeyRange.bound(lowerBound, upperBound);
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .getAll(range);
      } else {
        request = this.db.transaction(table).objectStore(table);
      }
      return request;
    }
  }

  async getItemRangeUpperBound(table, indexName, upperBound) {
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .openCursor(IDBKeyRange.upperBound(upperBound), "prev");
      } else {
        request = this.db.transaction(table).objectStore(table);
      }
      return request;
    }
  }

  getItemLowerBound(table, indexName, lowerBound) {
    var range = IDBKeyRange.lowerBound(lowerBound);
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .getAll(range);
      } else {
        request = this.db.transaction(table).objectStore(table).getAll(range);
      }
      return request;
    }
  }

  async getItemRangeOnly(table, indexName, bound) {
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .openCursor(IDBKeyRange.only(bound), "next");
      } else {
        request = this.db.transaction(table).objectStore(table);
      }
      return request;
    }
  }

  getItemMax(table, indexName, query) {
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .openCursor(null, "prev");
      } else {
        request = this.db.transaction(table).objectStore(table);
      }
      return request;
    }
  }

  getItemMaxCompositeOnsucss(table, indexName, lowerBound, upperBound) {
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .openCursor(IDBKeyRange.bound(lowerBound, upperBound), "prev");
      } else {
        request = this.db.transaction(table).objectStore(table);
      }
      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          resolve(request.result);
        };
      });
    }
  }

  getItemMaxComposite(table, indexName, lowerBound, upperBound) {
    if (this.db) {
      let request;
      if (indexName) {
        request = this.db
          .transaction(table)
          .objectStore(table)
          .index(indexName)
          .openCursor(IDBKeyRange.bound(lowerBound, upperBound), "prev");
      } else {
        request = this.db.transaction(table).objectStore(table);
      }
      return request;
    }
  }

  deleteItemBykey(table, key) {
    if (this.db) {
      const request = this.db
        .transaction(table, "readwrite")
        .objectStore(table)
        .delete(String(key));
      return request;
    }
  }

  deleteItemComposite(table, composite) {
    if (this.db) {
      const request = this.db
        .transaction(table, "readwrite")
        .objectStore(table)
        .delete(composite);
      return request;
    }
  }

  deleteTable(table) {
    if (this.db) {
      const request = this.db
        .transaction(table, "readwrite")
        .objectStore(table)
        .clear();
      return request;

    }
  }


  deleteItemListByIndex(
    storeName: string,
    indexName: string,
    keyRange: IDBKeyRange
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      const index = store.index(indexName);

      let deletedCount = 0;

      const request = index.openKeyCursor(keyRange);

      request.onsuccess = () => {
        const cursor = request.result;

        if (cursor) {
          store.delete(cursor.primaryKey);
          deletedCount++;
          cursor.continue();
        }
      };

      request.onerror = () => {
        reject(request.error);
      };

      transaction.oncomplete = () => {
        resolve(deletedCount);
      };

      transaction.onerror = () => {
        reject(transaction.error);
      };

      transaction.onabort = () => {
        reject(transaction.error);
      };
    });
 }


   async deleteDB() {
    if (this.db) {
      this.db.close();
      this.db = null;
    }

      // Unregister service workers to prevent open connections
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    registrations.forEach(registration => registration.unregister());
  }

    const dbName = environment.local_db;
    return new Promise((resolve, reject) => {
      const deleteRequest = indexedDB.deleteDatabase(dbName);

      deleteRequest.onsuccess = () => {
        resolve('done');
      };

      deleteRequest.onerror = (event) => {
        reject(event);
      };

      deleteRequest.onblocked = () => {
        alert('Please close all tabs or reload the page to complete deletion.');
        reject(new Error('Database deletion blocked'));
      };
    });
  }




  // async clearNdbxDatabases() {
  //   if (!indexedDB.databases) {
  //     console.warn('Your browser does not support indexedDB.databases(). Cannot list databases.');
  //     return;
  //   }

  //   const dbs = await indexedDB.databases();


  //   for (const db of dbs) {
  //     if (db.name && db.name.startsWith('ndbx_')) {
  //       console.log(`Deleting database: ${db.name}`);
  //       indexedDB.deleteDatabase(db.name);
  //     }
  //   }

  //   console.log('All ndbx_ databases cleared.');
  // }


  async clearNdbxDatabases(): Promise<void> {
  if (!indexedDB.databases) {
    console.warn('Your browser does not support indexedDB.databases()');
    return;
  }

  const dbs = await indexedDB.databases();

  const deletions = dbs
    .filter(db => db.name && db.name.startsWith('ndbx_'))
    .map(db => {
      return new Promise<void>((resolve, reject) => {
        console.log(`Deleting database: ${db.name}`);
        const req = indexedDB.deleteDatabase(db.name!);

        req.onsuccess = () => resolve();
        req.onerror = () => reject(req.error);
        req.onblocked = () =>
          reject(new Error(`Deletion blocked for ${db.name}`));
      });
    });

  await Promise.all(deletions);

  console.log('All ndbx_ databases cleared.');
}


}
